<script type="ts" >

</script>

<div class="card"> 
    <slot></slot>
</div>

<style>
    .card {
        border: 2px solid var(--primary-color);
        color: #333;
        border-radius: 15px;
        padding: 5px 10px 20px 30px;
        margin: 20px 0;
        position: relative;
        box-shadow: 4.0px 8.0px 8.0px hsl(0deg 0% 0% / 0.38);

    }
</style>